import React, { useEffect } from "react";
import feather from "feather-icons";

export default function HeaderPage() {
  useEffect(() => {
    feather.replace();
  }, []);

  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });

  return (
    <div className="row mt-4 py-3 px-2">
      <div className="col-12 col-md-6 d-flex justify-content-start align-items-start">
        <h1 className="header-title m-0">CLASS SCHEDULE</h1>
      </div>
      <div className="col-12 col-md-6 d-flex flex-column justify-content-end">
        <div className="d-flex justify-content-end align-items-center ms-4">
          <span className="badge-new-class d-flex align-items-center">
            <i className="bi bi-star-fill me-2"></i>
            New Class
          </span>
          <h6 className="badge-monthly ms-2 px-3">
            <span className="gradient-text">{currentDate}</span>
          </h6>
        </div>
      </div>
    </div>
  );
}
